import { CommonModule }                 from '@angular/common';
import { NgModule }                     from '@angular/core';
import { NgbTooltipModule }             from '@ng-bootstrap/ng-bootstrap';
import { SvgModule }                    from '@shared/components/svg/svg.module';
import { IndicateElsterFieldDirective } from '@shared/directives/indicate-elster-field/indicate-elster-field.directive';
import { IndicateElsterFieldComponent } from './indicate-elster-field.component';


@NgModule( {
	declarations: [
		IndicateElsterFieldComponent,
		IndicateElsterFieldDirective
	],
	imports: [
		// Angular
		CommonModule,

		// Third-party
		NgbTooltipModule,

		// Shared
		SvgModule
	],
	exports: [
		IndicateElsterFieldComponent,
		IndicateElsterFieldDirective
	]
} )
export class IndicateElsterFieldModule {}
